namespace TotalPoll {
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'dashboard-feedback-collector-component-template',
        bindings: {}
    })
    class DashboardFeedbackCollectorComponent {
        public visible = false;

        public constructor(private $scope) {
            if (this.shouldDisplayFeedbackForm()) {
                setTimeout(() => {
                    this.$scope.$applyAsync(() => {
                        this.visible = true;
                    });
                }, 1000);
            }
        }

        private STATE_KEY = 'totalpoll-marketing';

        private _state: any = angular.merge({
                feedback: {
                    collected: false,
                    lastRequestAt: null,
                }
            },
            JSON.parse(localStorage.getItem(this.STATE_KEY)) || {}
        );

        get state() {
            return this._state;
        }

        set state(state) {
            localStorage.setItem(this.STATE_KEY, JSON.stringify(state));
        }

        refreshState() {
            this.state = this.state;

            return this.state;
        }

        shouldDisplayFeedbackForm() {
            if (this.state.feedback.lastRequestAt === null) {
                this.state.feedback.lastRequestAt = Date.now();
                this.refreshState();
            }

            return !this.state.feedback.collected &&
                (Date.now() - this.state.feedback.lastRequestAt) > (7 * 24 * 60 * 60 * 1000);
        }

        markFeedbackAsCollected() {
            this.visible = false;
            this.state.feedback.collected = true;
            this.refreshState();
        }

        postponeFeedback() {
            this.visible = false;
            this.state.feedback.lastRequestAt = Date.now();
            this.refreshState();
        }
    }
}